



































































































































































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { AxiosVue } from '@/AxiosVue';
import { fetchAltasCrm } from './fetchAltasCrm';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { actionsEvent } from '@/setup';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { LoadingService } from '@/services/loadingService';
import moment from 'moment';

import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';

import ModalVerDetalleCrm from '@/pantallas/Conecta/AltasCrm/ModalVerDetalleCrm.vue';
import DownloadIcon from '@/pantallas/Conecta/AltasCrm/DownloadIcon.vue';

/* import DownloadIcon from './DownloadIcon.vue';
 */

@Component({
  components: {
    MantenedorGridSinCodigo,
    DatePicker,
    ModalVerDetalleCrm,
    DownloadIcon,
  },
})
export default class AltasDeServicioCrm extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.AltasCrm;

  model_filtro_inicio: any = null;
  model_filtro_fin: any = null;
  titleStartDate: string = 'Fecha de Creación Desde';
  titleEndDate: string = 'Fecha de Creación Hasta';
  model_filtro_cliente: any = null;
  filtro_cliente: any[] = [];
  model_filtro_alta: any = null;
  model_filtro_nota: any = null;
  filtro_serie: any[] = [];
  model_filtro_serie: any = null;
  altascrm: any = [];
  gridApi: GridApi = null;
  columnApi: any = null;
  data: any = {};
  AltaCrm_Seleccionada: any = null;
  AltaCrmModalState: boolean = false;
  esEdicion: boolean = false;
  accion_modal: String = '';
  NombreAlta: any = null;

  accionVerDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionVerDetalle];
  actions() {
    actionsEvent.onVerDetalle(this.handlerbuttonmodalVerDetalle);
  }
  constructor() {
    super();
    this.actions();
  }

  handlerbuttonmodalVerDetalle(params: ICellRendererParams) {
    this.data = params.data;
    this.AltaCrm_Seleccionada = params.data['id'];
    this.NombreAlta = params.data['nombrealtasservicio'];
    this.AltaCrmModalState = true;
    this.esEdicion = false;
    this.accion_modal = 'EDITAR';
  }
  @Watch('model_filtro_inicio')
  handlerStartDate() {
    if (this.model_filtro_inicio > this.model_filtro_fin) {
      this.model_filtro_fin = this.model_filtro_inicio;
    }
  }

  @Watch('model_filtro_fin')
  handlerEndDate() {
    if (this.model_filtro_fin < this.model_filtro_inicio) {
      this.model_filtro_inicio = this.model_filtro_fin;
    }
  }

  async cleanfilters() {
    this.model_filtro_inicio = moment(new Date()).subtract(1, 'months');
    this.model_filtro_fin = moment(new Date());
    this.model_filtro_cliente = null;
    this.model_filtro_serie = null;
    this.model_filtro_alta = null;
    this.model_filtro_nota = null;
    this.handleGridReady();
  }

  gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Alta de Servicio',
        field: 'nombrealtasservicio',
        width: 190,
      },
      /* {
        headerName: 'PDF',
        field: 'informepdf',
        cellStyle: { display: 'grid', placeItems: 'center' },
        width: 100,
        cellRendererFramework: DownloadIcon,
        cellRendererParams: (params: any) => ({
          data: params.data,
        }),
      }, */
      {
        headerName: 'Fecha de Creación',
        field: 'fechacreacion',
        width: 150,
      },
      {
        headerName: 'Cliente',
        field: 'nombrecliente',
        width: 180,
      },
      {
        headerName: 'RUT',
        field: 'rutcliente',
        width: 150,
      },
      {
        headerName: 'Ejecutivo de Venta',
        field: 'nombreejecutivoventa',
        width: 170,
      },
      {
        headerName: 'Tipo de Alta',
        field: 'nombretipoalta',
        width: 170,
      },
      {
        headerName: 'Razón del Estado CRM',
        field: 'nombrerazonestado',
        width: 160,
      },
      {
        headerName: 'Propietario',
        field: 'nombrepropietario',
        width: 170,
      },
      {
        headerName: 'Oportunidad',
        field: 'nombreoportunidad',
        width: 160,
      },
      {
        headerName: 'Cotización',
        field: 'nombrecotizacion',
        width: 140,
      },
      {
        headerName: 'Nota de Venta',
        field: 'nombrenotaventa',
        width: 140,
      },
      {
        headerName: 'Reactivación/Recuperación',
        field: 'nombrereactivacionrecuperacion',
        width: 190,
      },
      {
        headerName: 'Demostración Comercial',
        field: 'nombredemostracioncomercial',
        width: 190,
      },
      {
        headerName: 'Cantidad de Equipos',
        field: 'cantidadequipos',
        width: 170,
      },
      {
        headerName: 'Cantidad de Equipos Preparados',
        field: 'cantidadequipospreparados',
        width: 230,
      },
      {
        headerName: 'Cantidad de Equipos Instalados',
        field: 'cantidadequiposinstalados',
        width: 220,
      },
      {
        headerName: 'EPC',
        field: 'contieneepc',
        width: 140,
      },
      {
        headerName: 'Nombre del Contacto',
        field: 'nombrescontacto',
        width: 160,
      },
      {
        headerName: 'Teléfono de Contacto',
        field: 'telefonocontacto',
        width: 160,
      },
      {
        headerName: 'Email de Contacto',
        field: 'emailcontacto',
        width: 160,
      },
      {
        headerName: 'Dirección de Contacto',
        field: 'direccioncontacto',
        width: 160,
      },
      {
        headerName: 'Fecha Estimada de Instalación',
        field: 'fechaestimadainstalacion',
        width: 200,
      },
      {
        headerName: 'Observaciones de Instalación',
        field: 'observacionesinstalacion',
        width: 200,
      },
      {
        headerName: 'Tipo de Instalación',
        field: 'tipoinstalacion',
        width: 160,
      },
      {
        headerName: 'Autor',
        field: 'autor',
        width: 140,
      },
    ],
    rowSelection: 'multiple',
    pagination: true,
    paginationPageSize: 6, //Solución Paginación
    cacheBlockSize: 6, //Solución Paginación //Ordenamiento + Seleccion
    paginationAutoPageSize: false,
    rowModelType: 'normal',
    columnTypes: {
      fecha: {
        sortable: true,
        resizable: true,
        filter: true,
      },
    },
    suppressCsvExport: true,
    suppressExcelExport: true,
    onGridReady: this.onGridReady,
    overlayNoRowsTemplate: 'No hay filas para mostrar',
  };

  async handleGridReady() {
    await this.getFilters();
    this.altascrm = await this.get_grid_data_altas_crm();
    this.gridApi.setRowData(this.altascrm);
    this.gridApi.setDomLayout('autoHeight');
    /*     this.copy_scroll();
     */ this.model_filtro_inicio = moment(new Date()).subtract(1, 'months');
    this.model_filtro_fin = moment(new Date());
  }
  async getFilters() {
    try {
      this.loadingService.showLoading(undefined, 'getFilters');
      const result = await fetchAltasCrm({}, 'conecta_altas_crm/get_filters');
      this.filtro_cliente = result.data.CLIENTES.LISTA;
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 300 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { timeout: 300 }
      );
    } finally {
      this.loadingService.hideLoading('getFilters');
    }
  }
  async applyfilters() {
    let body: { [key: string]: string } = {
      filtro_cliente: this.model_filtro_cliente,
      filtro_serie: this.model_filtro_serie,
      filtro_inicio: this.model_filtro_inicio,
      filtro_fin: this.model_filtro_fin,
      filtro_alta: this.model_filtro_alta,
      filtro_nota: this.model_filtro_nota,
    };
    this.altascrm = await this.get_grid_data_altas_crm(body);
    this.gridApi.setRowData(this.altascrm);
    this.gridApi.setDomLayout('autoHeight');
    /*     this.copy_scroll();
     */
  }

  async get_grid_data_altas_crm(filter_data: any = null) {
    //this.gridApi.rowModel.rowsToDisplay = this.rowcount;
    let self = this;
    if (filter_data == null) {
      filter_data = { '': '' };
    }
    this.loadingService.showLoading(undefined, 'get_grid_data_altas_crm');
    return fetchAltasCrm(filter_data, 'conecta_altas_crm')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          if (data.data.data.LISTA[0].autor != undefined) {
            return data.data.data.LISTA;
          } else {
            return null;
          }
        }
      })
      .catch((error: any) => null)
      .finally(() =>
        this.loadingService.hideLoading('get_grid_data_altas_crm')
      );
  }

  async onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
    this.handleGridReady();
  }

  async modalverDetalleCallback(event: any) {
    this.AltaCrmModalState = event;
    this.altascrm = await this.get_grid_data_altas_crm();
    this.gridApi.setRowData(this.altascrm);
    /*         this.copy_scroll();
     */
  }

  handleCierreModalAsignacion() {
    actionsEvent.removeListeners();
    this.AltaCrmModalState = false;
    this.data = {};
    this.AltaCrm_Seleccionada = {};
    this.actions();
    this.handleGridReady();
  }
}
